export default function modal(state = {}, action) {
    switch (action.type) {
        case 'SHOW_MODAL':
            return action.data
        case 'HIDE_MODAL':
            return {}
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./app/reducers/modal.js